<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 24 }">
      <a-col :xs="24" :lg="24">
        <a-card>
          <div slot="title">
            <a-icon type="snippets" :style="{ color: '#30A679' }" />
            <span class="m-text-title"
              >&nbsp; Create Key Performance Indicator</span
            >
          </div>
          <div>
            <a-steps :current="current">
              <a-step
                v-for="item in steps"
                :key="item.title"
                :title="item.title"
              />
            </a-steps>
            <div class="steps-content">
              <Information v-if="steps[current].content == 'information'" />
              <TableCreate key="assignee" :columns="columnsAssignee" :dataTable="dataSourceAssignee" v-if="steps[current].content == 'assignee'" />
              <TableCreate key="accountable" :columns="columnsAccoutable" :dataTable="dataSourceAccountable" v-if="steps[current].content == 'accountable'" />
            </div>
            <div class="steps-action">
              <a-button
                v-if="current < steps.length - 1"
                type="primary"
                @click="next"
              >
                Next
              </a-button>
              <div>
                <a-button
                  style="margin-right: 20px;"
                  v-if="current == steps.length - 1"
                  type="secondary"
                  @click="$message.success('Processing complete!')"
                >
                  Save Draft
                </a-button>
                <a-button
                  v-if="current == steps.length - 1"
                  type="primary"
                  @click="$message.success('Processing complete!')"
                >
                  Submit
                </a-button>
              </div>
              <a-button
                v-if="current > 0"
                style="margin-left: 8px"
                @click="prev"
              >
                Previous
              </a-button>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import InformationCreateKPI from "./InformationCreateKPI";
import TableCreate from "@/views/kpi/create/TableCreate.vue";

export default {
  name: "Create",
  components: {
    Information: InformationCreateKPI,
    TableCreate: TableCreate
  },
  data() {
    return {
      kpiCreate: "kpiCreate",
      transactionDt: [],
      search: "",
      current: 0,
      steps: [
        {
          title: "Information",
          content: "information"
        },
        {
          title: "As Assignee",
          content: "assignee"
        },
        {
          title: "As Accountable",
          content: "accountable"
        }
      ],
      dataSourceAssignee: [
        {
          key: "0",
          objective: "Harmoni",
          kpi: "ubah data",
          accountable: "MZA",
          description:"deskripsi",
          source:"nirmala",
          frequently:null,
          formula:null,
          weight:null,
          uom:null,
          target:null,
          actual:null,
          percentage:null,
          kpiScore:null,
          status:null
        }
      ],
      columnsAssignee: [
        {
          title: "Objective",
          dataIndex: "objective",
          width: "7%"
        },
        {
          title: "KPI",
          dataIndex: "kpi"
        },
        {
          title: "Accountable",
          dataIndex: "accountable",
          width: "10%"
        },
        {
          title: "Indicator Description",
          dataIndex: "description",
          width: "13%"
        },
        {
          title: "Source",
          dataIndex: "source"
        },
        {
          title: "Frequently",
          dataIndex: "frequently",
          width: "8%",
          scopedSlots: { customRender: "frequently" }
        },
        {
          title: "Formula",
          dataIndex: "formula",
          scopedSlots: { customRender: "formula" }
        },
        {
          title: "Weight",
          dataIndex: "weight",
          scopedSlots: { customRender: "weight" }
        },
        {
          title: "UOM",
          dataIndex: "uom",
          width: "8%",
          scopedSlots: { customRender: "uom" }
        },
        {
          title: "Target",
          dataIndex: "target",
          scopedSlots: { customRender: "target" }
        },
        {
          title: "Actual",
          dataIndex: "actual",
          scopedSlots: { customRender: "actual" }
        },
        {
          title: "Percentage",
          dataIndex: "percentage",
          width: "8%"
        },
        {
          title: "Score",
          dataIndex: "kpiScore"
        },
        {
          title: "Status",
          dataIndex: "status"
        }
      ],
      dataSourceAccountable: [
        {
          key: "0",
          objective: "Harmoni",
          kpi: "ubah data",
          assignee: "NDY",
          description:"deskripsi",
          source:"nirmala",
          frequently:null,
          formula:null,
          weight:null,
          uom:null,
          target:null,
          actual:null,
          percentage:null,
          kpiScore:null,
          status:null
        }
      ],
      columnsAccoutable: [
        {
          title: "Objective",
          dataIndex: "objective",
          width: "7%"
        },
        {
          title: "KPI",
          dataIndex: "kpi"
        },
        {
          title: "Assignee",
          dataIndex: "assignee",
          width: "10%"
        },
        {
          title: "Indicator Description",
          dataIndex: "description",
          width: "13%"
        },
        {
          title: "Source",
          dataIndex: "source"
        },
        {
          title: "Frequently",
          dataIndex: "frequently",
          width: "8%",
          scopedSlots: { customRender: "frequently" }
        },
        {
          title: "Formula",
          dataIndex: "formula",
          scopedSlots: { customRender: "formula" }
        },
        {
          title: "Weight",
          dataIndex: "weight",
          scopedSlots: { customRender: "weight" }
        },
        {
          title: "UOM",
          dataIndex: "uom",
          width: "8%",
          scopedSlots: { customRender: "uom" }
        },
        {
          title: "Target",
          dataIndex: "target",
          scopedSlots: { customRender: "target" }
        },
        {
          title: "Actual",
          dataIndex: "actual",
          scopedSlots: { customRender: "actual" }
        },
        {
          title: "Percentage",
          dataIndex: "percentage",
          width: "8%"
        },
        {
          title: "Score",
          dataIndex: "kpiScore"
        },
        {
          title: "Status",
          dataIndex: "status"
        }
      ]
    };
  },
  methods: {
    next() {
      this.current++;
    },
    prev() {
      this.current--;
    }
  }
};
</script>

<style></style>
